import { AxiosError } from 'axios';
import { takeLatest, put, call } from 'redux-saga/effects';

import {
  getUserRequest,
  getUserFailure,
  getUserSuccess
} from '../features/user/user-slice';
import { getUser } from '../api';
import { User } from '../types/user';

function* ongetUser(): unknown {
  try {
    const response: User = yield call(getUser);
    yield put(getUserSuccess(response));
  } catch (error) {
    const axiosError = error as AxiosError;
    yield put(getUserFailure(axiosError));
  }
}

function* UserSaga(): Generator {
  yield takeLatest(getUserRequest.type, ongetUser);
}

export default UserSaga;
